import { Injectable } from '@angular/core';
import { SystemStore } from '@frontend-site/shared/core';
import { LocalStoragePersister } from '../../infrastructure/local-storage-persister';
import { PageId } from '../entities/last-page';

const PERSISTENCE_KEY = 'system_last_page';

const CAN_REMEMBER_ROUTE_MAPPING = new Map<PageId, (systemId: number) => string>([
    ['myERPs_system_ERPSnapshot_snapshotMain', (systemId: number): string => `/myERPs/${systemId}/ERPSnapshot/snapshotMain`],
    ['myERPs_system_fitness', (systemId: number): string => `/myERPs/${systemId}/fitness`],
    ['myERPs_system_testAssets', (systemId: number): string => `/myERPs/${systemId}/testAssets`],
    ['myERPs_system_satelliteMain', (systemId: number): string => `/myERPs/${systemId}/satellite`]
]);

@Injectable({ providedIn: 'root' })
export class SystemLastPageVisitedService {
    constructor(private readonly system: SystemStore, private readonly persister: LocalStoragePersister<PageId>) {}

    set(pageId: PageId): void {
        const rememberMePage = CAN_REMEMBER_ROUTE_MAPPING.get(pageId);
        if (!rememberMePage) {
            return;
        }

        this.persister.set(PERSISTENCE_KEY, pageId);
    }

    get(): string | null {
        const systemId = this.system.systemId;
        if (!systemId) {
            return null;
        }

        const lastPageId = this.persister.get(PERSISTENCE_KEY);
        if (!lastPageId) {
            return null;
        }

        const page = CAN_REMEMBER_ROUTE_MAPPING.get(lastPageId);
        if (!page) {
            return null;
        }

        return page(systemId);
    }
}
